export const ChatBox = ({ children }) => {
    return <div className="position-relative">{children}</div>;
};
